import * as Text from './Text';

export default {
    ...Text,
};
